import { $, $$ } from '../utils/dom';

const getAndSetTheme = () => {
    let storageTheme = window.localStorage.getItem('theme');
    let theme = $('[data-theme]');

    if (storageTheme === null) {
        window.localStorage.setItem('theme', 'default');
    }

    if (storageTheme === 'default') {
        theme.setAttribute('data-theme', 'default');
    }

    if (storageTheme === 'rainbow') {
        theme.setAttribute('data-theme', 'rainbow');
    }
};

document.addEventListener("DOMContentLoaded", () => {
    getAndSetTheme();
});

const changeTheme = () => {
    let storageTheme = window.localStorage.getItem('theme');
    let theme = $('[data-theme]');
    let currentTheme = theme.getAttribute('data-theme');
    
    if (currentTheme === 'default') {
        theme.setAttribute('data-theme', 'rainbow');
        window.localStorage.setItem('theme', 'rainbow');
    }
    else {
        theme.setAttribute('data-theme', 'default');
        window.localStorage.setItem('theme', 'default');
    }
};

const themeButton = $('[data-theme-button]');

if (themeButton) {
    themeButton.addEventListener('click', () => {
        changeTheme();
    })
}
